export const LANG_REGEX: RegExp = /\/([\w]{2})\//g;

const DEFAULT_LANG = '/en/';

export const hasLanguageInPathname = () => {
  const result = LANG_REGEX.test(location.pathname);
  LANG_REGEX.lastIndex = 0;
  return result;
}

export const urlLang = () => {
  const hasLanguage = hasLanguageInPathname();
  if (hasLanguage) {
    const execRegex: RegExpExecArray = LANG_REGEX.exec(location.pathname);
    LANG_REGEX.lastIndex = 0;
    return execRegex.length > 0 ? execRegex[0] : DEFAULT_LANG;
  }
  return DEFAULT_LANG;
};

export const getLocale = () => {
  const localeWithSlashes = urlLang();
  const shouldDefault = !localeWithSlashes || (localeWithSlashes && localeWithSlashes.length < 4);
  if(shouldDefault) {
    return DEFAULT_LANG.slice(1,3);
  }
  return localeWithSlashes.slice(1,3);
}